<template>
  <div class="menu clear-fix">
  	<div class="menubaoxs">
	  	<div class="menu-item" @click="goclasslist">
	      <span class="menu-item-title classlist">Categories</span>
	    </div>
	    <div class="menu-item" @click="goStoreclass">
	      <span class="menu-item-title">Store</span>
	    </div>
	   <!-- <div class="menu-item videomenus" @click="govideolist">
	      <span class="menu-item-title">Video</span>
	    </div> -->
	   <!-- <div class="menu-item" @click="golive">
	      <span class="menu-item-title">Live</span>
	    </div> -->
	   <!-- <div class="menu-item">
	      <span class="menu-item-title">
	      <a href="https://h5.duoyp.com">中国站</a></span>
	    </div> -->
	    <!--<div class="menu-item" @click="goselfshop">
	      <span class="menu-item-title">DYP Store</span>
	    </div>-->
	    
	    <!--<div class="menu-item" @click="goLivebroadcast">
	      <span class="menu-item-title exyzbox">628 Event</span>
	    </div>-->
			
			<!--<div class="menu-item" @click="goChainNearby">
	      <span class="menu-item-title">周边</span>
	    </div>
			<div class="menu-item" @click="gocontactus">
	      <span class="menu-item-title">联系我们</span>
	    </div>
	    <div class="menu-item" @click="goArticleclass">
	      <i class="iconfont bg-4">&#xe674;</i>
	      <span class="menu-item-title">帮助中心</span>
	    </div>
	    <div class="menu-item" @click="goMemberIndex">
	      <i class="iconfont bg-2">&#xe68c;</i>
	      <span class="menu-item-title">个人中心</span>
	    </div>-->
	    <div class="menu-item"  v-for="(item, index) in navs" :key="index" @click="goAdUrl(item)">
	      <img class="menu-item-icon" :src="item.adv_code" />
	      <span class="menu-item-title">{{item.adv_title}}</span>
	    </div>
	  </div>  
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HomeMenu',
  props: ['items'],
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      navs: state => state.home.navs
    })
  },
  methods: {
  	goclasslist () {
      this.$router.push({ name: 'HomeGoodsclass' })
   },
    goStoreclass () {
      this.$router.push({ 'name': 'HomeStorelist' })
    },
    golive(){
    	this.$router.push({ 'name': 'MemberLiveLists' })
    },
    gohome () {
      this.$router.push({ 'name': 'HomeIndex',query:{lang:'en'} })
    },
    goselfshop () {     
      this.$router.push({ 'name': 'HomeStoredetail', query: { id: '4607' } })
    },
    goChainNearby(){
    	this.$router.push({ 'name': 'HomeChainNearby' })
    },
    gocontactus () {
      this.$router.push({ 'name': 'HomeArticledetail', query: { article_id: '23' } })
    },
    goLivebroadcast () {
//    window.location.href = 'https://h5.duoyp.com/member/live_list'
			this.$router.push({ 'name': 'HomeLiveIndex' })
    },
    govideolist(){
			this.$router.push({ 'name': 'HomeVideoList' })
		},
    myOrder () {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goAdUrl (item) {
      switch (item.adv_type) {
        case 'goods':
          this.$router.push({ 'name': 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
          break
        case 'store':
          this.$router.push({ 'name': 'HomeStoredetail', query: { id: item.adv_typedate } })
          break
        case 'article':
          this.$router.push({ 'name': 'HomeArticledetail', query: { article_id: item.adv_typedate } })
          break
        case 'url':
          window.location.href = item.adv_typedate
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.clear-fix{overflow: auto;}
.clear-fix::-webkit-scrollbar {display: none;}
.menubaoxs{width: 25rem;overflow: auto;}
  .menu {justify-content: space-around;padding-top:0.3rem;padding-bottom: 0.3rem;}
  .menu-item{text-align:center;float: left;display: inline-block;margin-right: 0.5rem;color: #fff;font-size: 0.7rem;padding-top: 0.15rem;}
  .menu .menu-item:nth-last-child(1){margin-right: 0rem;}
  .iconfont{margin:auto;width: 0.6rem;height: 0.6rem;line-height:0.6rem;font-size:1.4rem;color:#fff;overflow: hidden;
  display:block;text-align: center;border-radius:50%;}
  .menu-item-icon {width: 0.7rem;height: auto;display: inline-block;float: left;margin-top: 0.2rem;margin-right: 0.15rem;}
      .menu-item-title {
        display:inline-block;
        color: #fff;
        font-weight: bold;
        font-size:.8rem;
        margin-top:0rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

  .bg-1{background-image: linear-gradient(to bottom , #d69dcc,#e8198b );}
  .bg-2{background-image: linear-gradient(to bottom , #04befe,#4481eb );}
  .bg-3{background-image: linear-gradient(to bottom , #cc208e,#6713d2 );}
  .bg-4{background-image: linear-gradient(to bottom , #ff9a44,#fc6076 );}
  .bg-5{background-image: linear-gradient(to bottom , #00ecbc,#007adf );}
  .bg-6{background-image: linear-gradient(to bottom , #ff8177,#b12a5b );}
  
  .classlist{padding-left: 1.2rem;background: url(../../../assets/image/classlist.png);background-repeat: no-repeat;background-size: 1rem;background-position: left center;}
  .classlist{background-image: none;padding-left: 0;}
  .exyzbox{color: #FFFF00;}
  .menu-item{padding-top: 0.4rem;}
  .videomenus{padding: 0.4rem 0.8rem 0rem 0.4rem;background-image: url(../../../assets/image/video/menubj.png);background-position: left 0px top -1px;background-size: contain;background-repeat: no-repeat;color: #FF0000;}
  .videomenus span{color: #FF0000;}
  .menu-item-title a{color: #fff;font-size:.75rem;}
</style>
